import Model from "../Model.js";

/**
 * Specifies whether an agency is being billed.
 */
export default class AbstractAgencyBillingStatus extends Model {
	getType() {
		return this.constructor.getType();
	}
}
